import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateCompany } from "./api";
import { invalidateAllCompaniesQueries } from "../query";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateCompany() {
  return useMutation({
    mutationFn: async ({ item, companyId }) => {
      const payload = buildPayload(item);
      const response = await updateCompany({ item: payload, companyId });
      return response;
    },
    onSuccess: () => {
      toast.success("Company Updated Successfully");
      invalidateAllCompaniesQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
